module.exports = __webpack_public_path__ + "fonts/68c177c.woff2";